import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PathwayHeader = ({ 
  userRole = 'Developer', 
  completionPercentage = 65, 
  totalModules = 12, 
  completedModules = 8,
  onViewCertifications,
  onViewProgress 
}) => {
  const getRoleIcon = (role) => {
    const roleIcons = {
      'Developer': 'Code',
      'Project Manager': 'Users',
      'Business Analyst': 'BarChart3',
      'Product Designer': 'Palette'
    };
    return roleIcons?.[role] || 'BookOpen';
  };

  const getRoleColor = (role) => {
    const roleColors = {
      'Developer': 'bg-blue-500',
      'Project Manager': 'bg-green-500',
      'Business Analyst': 'bg-purple-500',
      'Product Designer': 'bg-orange-500'
    };
    return roleColors?.[role] || 'bg-primary';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center space-x-4">
          <div className={`w-12 h-12 ${getRoleColor(userRole)} rounded-lg flex items-center justify-center`}>
            <Icon name={getRoleIcon(userRole)} size={24} color="white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">{userRole} Learning Pathway</h1>
            <p className="text-muted-foreground">Specialized curriculum for smart city development</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground">{completionPercentage}%</div>
            <div className="text-sm text-muted-foreground">Complete</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground">{completedModules}/{totalModules}</div>
            <div className="text-sm text-muted-foreground">Modules</div>
          </div>
          <div className="flex space-x-2">
            <Button variant="outline" size="sm" onClick={onViewCertifications} iconName="Award" iconPosition="left">
              Certifications
            </Button>
            <Button variant="default" size="sm" onClick={onViewProgress} iconName="TrendingUp" iconPosition="left">
              View Progress
            </Button>
          </div>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="mt-4">
        <div className="flex justify-between text-sm text-muted-foreground mb-2">
          <span>Overall Progress</span>
          <span>{completionPercentage}% Complete</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${completionPercentage}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default PathwayHeader;